/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ProblemServiceUnavailable } from './ProblemServiceUnavailable';

export const ServiceUnavailableProblems: core.serialization.Schema<
    serializers.ServiceUnavailableProblems.Raw,
    Truvity.ServiceUnavailableProblems
> = core.serialization
    .union('type', {
        '/service-unavailable': ProblemServiceUnavailable,
    })
    .transform<Truvity.ServiceUnavailableProblems>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace ServiceUnavailableProblems {
    export type Raw = ServiceUnavailableProblems.ServiceUnavailable;

    export interface ServiceUnavailable extends ProblemServiceUnavailable.Raw {
        type: '/service-unavailable';
    }
}
